import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { journeyRadioIllustrationColors as colors } from './constants';
import { JourneyRadioIllustrationColors } from './types';

export const OtherJourneyEntrySource = ({
  height = 80,
  width = 80,
  backgroundColor = colors.backgroundColor,
  lineColor = colors.lineColor,
  fillColor = colors.fillColor,
  fillSecondaryColor = colors.fillSecondaryColor,
}: SvgIconProps & JourneyRadioIllustrationColors) => (
  <SvgIcon width={width} height={height} viewBox="0 0 80 80" fill="none">
    <path
      d="M8 40C8 44.2023 8.8277 48.3635 10.4359 52.2459C12.044 56.1283 14.4011 59.6559 17.3726 62.6274C20.3441 65.5989 23.8717 67.956 27.7541 69.5641C31.6365 71.1723 35.7977 72 40 72C44.2023 72 48.3635 71.1723 52.2459 69.5641C56.1283 67.956 59.6559 65.5989 62.6274 62.6274C65.5989 59.6559 67.956 56.1283 69.5641 52.2459C71.1723 48.3635 72 44.2023 72 40C72 35.7977 71.1723 31.6365 69.5641 27.7541C67.956 23.8717 65.5989 20.3441 62.6274 17.3726C59.6559 14.4011 56.1283 12.044 52.2459 10.4359C48.3635 8.8277 44.2023 8 40 8C35.7977 8 31.6365 8.8277 27.7541 10.4359C23.8717 12.044 20.3441 14.4011 17.3726 17.3726C14.4011 20.3441 12.044 23.8717 10.4359 27.7541C8.8277 31.6365 8 35.7977 8 40Z"
      fill={backgroundColor}
    />
    <path
      d="M28.0039 10.153C28.0039 8.96394 28.9678 8 30.1569 8H49.3769C50.566 8 51.5299 8.96394 51.5299 10.153V17.0481C51.5299 18.2371 50.566 19.2011 49.3769 19.2011H30.1569C28.9678 19.2011 28.0039 18.2371 28.0039 17.0481V10.153Z"
      fill="white"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.123 53.5876C31.123 52.3985 32.087 51.4346 33.2761 51.4346H46.2598C47.4489 51.4346 48.4129 52.3985 48.4129 53.5876V60.4826C48.4129 61.6717 47.4489 62.6356 46.2598 62.6356H33.2761C32.087 62.6356 31.123 61.6717 31.123 60.4826V53.5876Z"
      fill="white"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2412 36.0446C16.2412 34.8555 17.2051 33.8916 18.3942 33.8916H32.025C33.2141 33.8916 34.178 34.8555 34.178 36.0446V42.9397C34.178 44.1287 33.2141 45.0927 32.025 45.0927H18.3942C17.2052 45.0927 16.2412 44.1287 16.2412 42.9397V36.0446Z"
      fill="white"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.3916 36.0446C46.3916 34.8555 47.3555 33.8916 48.5446 33.8916H62.1754C63.3645 33.8916 64.3284 34.8555 64.3284 36.0446V42.9397C64.3284 44.1287 63.3645 45.0927 62.1754 45.0927H48.5446C47.3555 45.0927 46.3916 44.1287 46.3916 42.9397V36.0446Z"
      fill="white"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.0449 19.1992V51.432"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M55.3579 33.8893V27.1729C55.3579 26.0683 54.4625 25.1729 53.3579 25.1729H26.1758C25.0712 25.1729 24.1758 26.0683 24.1758 27.1729V33.8893"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="30.4316" y="10.5107" width="6.17948" height="6.17948" rx="1.07651" fill={fillColor} />
    <rect x="19.0303" y="36.4014" width="6.17948" height="6.17948" rx="1.07651" fill={fillColor} />
    <rect x="49.1787" y="36.4014" width="6.17948" height="6.17948" rx="1.07651" fill={fillColor} />
    <rect
      x="33.5889"
      y="53.9453"
      width="6.17948"
      height="6.17948"
      rx="1.07651"
      fill={fillSecondaryColor}
    />
  </SvgIcon>
);
